/**
 * Project rows and their expanded measuring point rows share one table, so both
 * line up on these grid columns. Project cells span two grid columns where a
 * measuring point row shows more detail.
 *
 * | grid column  | project row         | measuring point row |
 * | ------------ | ------------------- | ------------------- |
 * | 1            | starred             | (indent)            |
 * | 2            | name                | name                |
 * | 3            | city                | city                |
 * | 4            | alerts              | status              |
 * | 5, 6         | status (colSpan 2)  | device, last contact|
 * | 7            | total               | configuration       |
 * | 8            | options             | options             |
 * | 9            | expand button       | (empty)             |
 *
 * Starred, options and expand have a fixed width so their buttons always fit; the name column
 * takes whatever space is left.
 */
export const OVERVIEW_GRID_COLUMN_WIDTHS = [
    '4.5rem',
    'auto',
    '11%',
    '10%',
    '10%',
    '9%',
    '9%',
    '11rem',
    '3.75rem',
];

export const OVERVIEW_GRID_COLUMN_COUNT = OVERVIEW_GRID_COLUMN_WIDTHS.length;

/**
 * The Standalone tab lists measuring points in a table of their own, without the project
 * columns, so it has its own widths, in rem.
 */
export const STANDALONE_COLUMN_WIDTHS_REM = {
    name: 14,
    city: 8,
    status: 6,
    device: 10,
    lastContact: 10,
    options: 15,
} as const;
